import plugin from 'tailwindcss/plugin';
/**
 * Custom background images for the design system. Used for gradients.
 */
const backgroundImage = {
  'gradient-neon': 'linear-gradient(109deg, #6941C6 0%, #E31B54 106.38%)',
  'gradient-overlay': 'linear-gradient(180deg, rgba(121, 80, 242, 0) 50%, rgba(121, 80, 242, 0.5) 100%)',
  'gradient-green-stripe': 'repeating-linear-gradient(-45deg, transparent, transparent 2px, #16B364 3px, #16B364 4px)',
  'gradient-selected': 'linear-gradient(109deg, rgba(105, 65, 198, 0.10) 0%, rgba(227, 27, 84, 0.10) 106.38%)',
  'gradient-neon-hover':
    'linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%), linear-gradient(109deg, #6941C6 0%, #E31B54 106.38%)',
  'gradient-blur': 'linear-gradient(180deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.8) 100%)',
  'gradient-linear-12-border': 'linear-gradient(25deg, #7B6AE0 0%, #FFBB89 100%)',
  'gradient-purple-border': 'linear-gradient(180deg, #FBC2EB 0%, #A18CD1 105.25%)',
};

/**
 * Plugin to add a utility class to support a dot grid background image
 */
const backgroundImagePlugin = plugin(({ addUtilities }) => {
  addUtilities({
    '.bg-dot-grid': {
      backgroundImage: 'radial-gradient(#D5D7DA 1px, transparent 1px)', // #D5D7DA is utility-gray-300
      backgroundSize: '23px 23px',
      backgroundColor: '#FFF',
    },
  });
});

export { backgroundImage, backgroundImagePlugin };
